import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28.38,6a5,5,0,0,0-4-2H23.8A3,3,0,0,0,21,2H12A3,3,0,0,0,9,5H7A2,2,0,0,0,3,5v6a2,2,0,0,0,4,0H9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3V10h.67l.8.26a2.49,2.49,0,0,0,.85.14A2.69,2.69,0,0,0,29,8.16,2.81,2.81,0,0,0,28.38,6Z"/><path d="M12,25.35v.16a4.4,4.4,0,0,0,2.54,4.07A4.53,4.53,0,0,0,21,25.5v-.15L20.12,14H12.88ZM16.5,23a2,2,0,1,1-2,2A2,2,0,0,1,16.5,23Z"/>';
export var HammerSVG = function HammerSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
HammerSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(HammerSVG);